import { Component, Input } from "@angular/core";
import { ProgressBarStyle } from "./progressBar.component";

export class StackedProgressBarItem {
    public value: number;
    public text: string;
    public style: ProgressBarStyle;
    public legend: string;
}

@Component({
    selector: "stacked-progress-bar",
    templateUrl: "./stackedProgressBar.component.html",
    standalone: false
})
export class StackedProgressBarComponent {
    public progressBarStyle = ProgressBarStyle;
    @Input() public min: number = 0;
    @Input() public max: number = 100;
    @Input() public mainLegend: string;
    @Input() public data: StackedProgressBarItem[];
    @Input() public width: number;
}